import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'
import {
  SegmentedControl,
  SegmentedControlTab,
} from '@ui/components/SegmentedControl/SegmentedControl'

import { Box } from '@shared/components/Box'

import { ACCOUNT_SWITCH_MENU_ID } from '../menuSections/useAccountSwitchMenu'

interface Props {
  onClick?: () => void
  tabs: SegmentedControlTab[]
  activeTabId?: string
  isProductSwitch: boolean
  isAccountSwitch?: boolean
}

export const AccountProductSwitch: FC<Props> = ({
  tabs,
  activeTabId,
  isProductSwitch,
  isAccountSwitch,
}) => {
  const { t } = useTranslation()

  return (
    <Box flex direction='column' justify='center' align='center' gap='x32'>
      <SegmentedControl
        size='md'
        mode='solid'
        variant='primary'
        activeTab={activeTabId}
        isMobile
        tabs={tabs}
      />

      {isAccountSwitch && (
        <Body1>
          {activeTabId === ACCOUNT_SWITCH_MENU_ID.PARTNER
            ? t('Switch from Traders to Partners Area switcher info')
            : t('Switch from Partners to Traders Area switcher info')}
        </Body1>
      )}

      {isProductSwitch && (
        <Box flex direction='column' gap='x16'>
          <Body1>{t('General info about CFD and ETD')}</Body1>
          <Box flex direction='column' gap='x16'>
            <Body1>
              {t('CFDs (Contracts for difference) and Futures (Exchange traded derivatives)')}
            </Body1>
            <Body1>
              {t('Although they share many similarities, they also present several differences')}
            </Body1>
          </Box>
        </Box>
      )}
    </Box>
  )
}
